
import { useEffect, useRef } from 'react';
import { useAuthContext } from '@/contexts/auth';
import { useStore } from '@/store/useStore';

/**
 * Componente responsabile per la sincronizzazione dello stato di autenticazione
 * tra il contesto React (AuthContext) e lo store Zustand.
 * 
 * 🛡️ HYDRATION-SAFE: La sincronizzazione è differita al prossimo tick dell'event loop
 * per prevenire React error #421 ("Suspense boundary received an update before it finished hydrating").
 * 
 * Pattern: setTimeout(0) schedula l'esecuzione DOPO che l'hydration è completa.
 */
export function AuthSync() {
  const { user, isAuthenticated, isLoading } = useAuthContext();
  const { syncWithAuthContext } = useStore();
  
  // Track if we've completed the first deferred sync
  const hasSyncedOnce = useRef(false);
  
  // Effetto per sincronizzare lo stato di autenticazione
  useEffect(() => {
    // 🛡️ FIX: Defer sync to next event loop tick to ensure hydration is complete
    // This prevents React error #421 when Zustand store update triggers re-render during hydration
    const timeoutId = setTimeout(() => {
      // Passa lo stato di autenticazione attuale allo store
      syncWithAuthContext(user, isAuthenticated, isLoading);
      hasSyncedOnce.current = true;
    }, 0);
    
    return () => clearTimeout(timeoutId);
  }, [user, isAuthenticated, isLoading, syncWithAuthContext]);
  
  // Questo componente non renderizza nulla
  return null;
}

export default AuthSync;
